import React from "react";

import Dropdown from "@techsoftware/happay-widgets/Dropdown";

export default class CustomDropdown extends React.Component {
    render() {
        const props = this.props;
        const wrapperClass = `${
            props.removeMargin ? "" : "hw-customTextInput-wrapper"
        } ${props.parentWrapperClass || ""}`;
        return (
            <Dropdown
                key={props.key}
                isMultiSelect={props.type === "multi-select"}
                hideClearAll={props.hideClearAll}
                errorText={props.errorText}
                isRequired={props.isRequired || props.required}
                dropdownInputHintText={
                    props.dropdownInputHintText || `${props.labelText || props.floatingLabelText}`
                }
                labelText={props.labelText || props.floatingLabelText}
                clearMargin={props.clearMargin}
                value={props.value}
                onChange={props.onChange}
                dataConfig={props.dataConfig}
                data={props.data}
                style={props.style}
                floatingLabelStyle={props.floatingLabelStyle}
                disabled={props.disabled}
                isSearchableInput={props.isSearchableInput}
                isLoader={props.isLoader}
                valueType={props.valueType}
                asyncSearch={props.asyncSearch}
                handleAsyncSearch={props.handleAsyncSearch}
                parentWrapperClass={wrapperClass}
                borderType={"light"}
                multiSelectValueType={props.multiSelectValueType}
                valueToShowInMultiDDAlways={props.valueToShowInMultiDDAlways}
                {...props}
            />
        );
    }
}

CustomDropdown.defaultProps = {
    multiSelectValueType: "value"
};
